var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-dotted-btn rounded-lg pa-3 px-0"},[_c('j-btn',_vm._g(_vm._b({},'j-btn',_vm.$props,false),_vm.$listeners),[_c('span',[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }